import { render, staticRenderFns } from "./RelatedSelect.vue?vue&type=template&id=e13b3898"
import script from "./RelatedSelect.vue?vue&type=script&lang=js"
export * from "./RelatedSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports